$ = require 'jquery'
Alerts = require 'app/scripts/views/lib/alerts'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
templates = require 'app/scripts/views/internal/templates'
{ track, trackUe } = require '@trello/analytics'

TEMPLATES_ALERT_TIMEOUT = 1000

module.exports = class ConvertToTemplateView extends View
  viewTitleKey: 'convert to template'

  initialize: ({ hasDismissedFirstTemplateMessage, dismissMessage }) ->
    @hasDismissedFirstTemplateMessage = hasDismissedFirstTemplateMessage
    @dismissMessage = dismissMessage

  events:
    'submit form': 'convertToTemplate'

  render: ->
    @$el.html(templates.fill('board_convert_template'))

    @

  convertToTemplate: (e) ->
    Util.stop(e)
    @$('.js-convert').prop('disabled')

    Alerts.show('converting', 'info', 'templates', TEMPLATES_ALERT_TIMEOUT)

    if !@hasDismissedFirstTemplateMessage
      @dismissMessage()

    @model.setPref('isTemplate', true).save()
    @model.setPref('comments', 'disabled').save()
    @model.setPref('selfJoin', false).save()

    trackUe('board menu', 'converts', 'board', 'to template', '', 'by clicking template toggle',
      { boardId: @model.id, teamId: @model.getOrganization()?.id })

    return
